export default __webpack_public_path__ + "static/media/Type F main cover.ae2c55fc.png";